/** Beside a column in a Dynamics row, the text Dynamics shows for it: a choice's label, a lookup's name. */
export const FORMATTED = '@OData.Community.Display.V1.FormattedValue';
/** Beside a lookup's `_x_value`, the table the reference points to. */
export const LOOKUP_TABLE = '@Microsoft.Dynamics.CRM.lookuplogicalname';

/** A cell as text: empty for a missing value, never "null" or "undefined". */
export function text(value: unknown): string {
  return value === null || value === undefined ? '' : String(value);
}

/** The text Dynamics formatted for `attribute`; empty when it sent none. */
export function formattedText(
  row: Record<string, unknown> | null | undefined,
  attribute: string,
): string {
  return text(row?.[`${attribute}${FORMATTED}`]);
}

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** A record id, checked before it goes into a query unescaped. */
export function isGuid(value: string | null | undefined): value is string {
  return !!value && GUID.test(value);
}

/** The client hands date columns back as `Date`; a Date Only one is midnight UTC, so the UTC date is the day. */
export function isoOf(value: unknown): string {
  return value instanceof Date ? value.toISOString() : text(value);
}

/** A number cell; null when empty or not a number. */
export function numberOrNull(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/** An id as ids are compared here: Dynamics answers in lower case, a device may mint upper. */
export function idOf(value: unknown): string {
  return text(value).toLowerCase();
}
